import {
  Page,
  useModals,
  Button,
  ButtonLink,
  FontAwesomeIcon,
  Skeleton,
  Stack,
} from "@skailer-com/uikit";
import usePermissions from "@/hooks/use-permissions.hook.ts";
import { useTitle } from "@/hooks/use-title.hook.ts";
import { BlogChannelPosts } from "@/pages/blog/index/components/BlogChannelPosts.tsx";
import { BlogChannelsList } from "@/pages/blog/index/components/BlogChannelsList.tsx";
import { BlogChannelEditModal } from "@/pages/blog/index/widgets/BlogChannelEditModal.tsx";
import { BlogConfigureMyFeed } from "@/pages/blog/index/widgets/BlogConfigureMyFeed.tsx";
import { useBlogMyChannels } from "@/queries/blog.query.ts";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";
import { ApiBlogChannelCan } from "@/types/blog.types.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";

export function BlogPage() {
  const { openModal } = useModals();
  const { t } = useTranslation();
  const { canIEdit } = usePermissions();
  const { data: channelsForPublish, isLoading: isLoadingChannelsForPublishing } = useBlogMyChannels(
    {
      can: ApiBlogChannelCan.publish,
    }
  );

  useTitle(t("blog:blog"));

  const handleAddChannel = () => {
    openModal(BlogChannelEditModal);
  };

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.blog.channelViewed);
  });

  return (
    <Page variant="opaque">
      <Page.Header title={t("blog:news_and_updates")}>
        <Stack gap={"sm"} direction={"horizontal"}>
          {isLoadingChannelsForPublishing ? (
            <Skeleton className={"w-32 h-7"} />
          ) : (
            <>
              <Button
                variant={"secondary"}
                onClick={() => {
                  openModal(BlogConfigureMyFeed);
                }}
              >
                {t("blog:configure_my_feed")}
              </Button>
              {canIEdit(ApiPermission.news_manage_channels) && (
                <Button variant={"secondary"} onClick={handleAddChannel}>
                  {t("blog:new_feed")}
                </Button>
              )}
              {channelsForPublish && channelsForPublish.length > 0 && (
                <ButtonLink
                  href={"/news/posts/new"}
                  leftIcon={<FontAwesomeIcon icon="fa-light fa-plus" />}
                >
                  {t("blog:new_post")}
                </ButtonLink>
              )}
            </>
          )}
        </Stack>
      </Page.Header>
      <Page.Content className={"py-6 px-16"}>
        <Stack gap={"2xl"}>
          <BlogChannelsList />
          <BlogChannelPosts />
        </Stack>
      </Page.Content>
    </Page>
  );
}
